import { APP_BASE_URL } from '../appconfig/Settings';
import axiosInstance from '../config/axiosInstance';

//common api call start

// get All Simple Details
export const getAllDetails = async (slug: any) => {
    try {
        const response = await axiosInstance(APP_BASE_URL + slug);
        return response?.data.data;
    } catch (error) {
        throw error;
    }
};

export const getAllDetailsDirect = async (slug: any) => {
    try {
        const response = await axiosInstance(APP_BASE_URL + slug);
      
        return response?.data;
    } catch (error) {
        throw error;
    }
};

//get Details from id
export const getDetailsFromId = async (slug: any, parameterName: any, id: any) => {
    try {
        const response = await axiosInstance(APP_BASE_URL + slug + `${'?' + parameterName}=` + id);
        return response?.data.data;
    } catch (error) {
        throw error;
    }
};

//getSpecificItemDeyails
export const getSpecificItemDetails = async (slug: any, firstParameterName: any, firstValue: any , secParameterName:any,secValue:any ) => {
    try {
        const response = await axiosInstance(APP_BASE_URL + slug + `${'?' + firstParameterName}=` + firstValue + `${'&'+secParameterName}=` + secValue);
        return response?.data.data;
    } catch (error) {
        throw error;
    }
};

//getSpecificItemDeyails
export const getFilteredDetails = async (slug: any, firstParameterName: any, firstValue: any , secParameterName:any, secValue:any, thirdParameterName : any, thirdValue : any, fourthParameterName : any, fourthValue : any) => {
    try {
        const response = await axiosInstance(APP_BASE_URL + slug + `${'?' + firstParameterName}=` + firstValue + `${'&'+secParameterName}=` + secValue + `${'&' + thirdParameterName}=` + thirdValue +  `${'&' + fourthParameterName}=` + fourthValue );
        return response?.data.data;
    } catch (error) {
        throw error;
    }
};

//getSpecificItemDeyails
export const getDateFilteredDetails = async (slug: any, firstParameterName: any, firstValue: any , secParameterName:any, secValue:any, thirdParameterName : any, thirdValue : any) => {
    try {
        const response = await axiosInstance(APP_BASE_URL + slug + `${'?' + firstParameterName}=` + firstValue + `${'&'+secParameterName}=` + secValue + `${'&' + thirdParameterName}=` + thirdValue  );
        return response?.data.data;
    } catch (error) {
        throw error;
    }
};

//getSpecific Details from id
export const getSpecificDetailsById = async (slug: any, id: any) => {
    try {
        const response = await axiosInstance(APP_BASE_URL + slug + '/' + id);
        return response?.data.data;
    } catch (error) {
        throw error;
    }
};
//common get api
export const getAllData = async (slug: any, requestData: any) => {
    try {
        const response = await axiosInstance(APP_BASE_URL + slug, requestData);
        return response?.data.data;
    } catch (error) {
        throw error;
    }
};

//common post api
export const postAllData = async (slug: any, requestData: any) => {
    try {
        const response = await axiosInstance.post(APP_BASE_URL + slug, requestData);
       
        return response?.data;
    } catch (error) {
        throw error;
    }
};

//updateData
export const updateData = async (slug: any, id: any, requestData: any) => {
    try {
        const response = await axiosInstance.post(APP_BASE_URL + slug + '/' + id, requestData);
        return response?.data;
    } catch (error) {
        throw error;
    }
};

//delete data
export const deleteData = async (slug: any, id: any) => {
    try {
        const response = await axiosInstance.delete(APP_BASE_URL + slug + '/' + id);
        return response?.data;
    } catch (error) {
        throw error;
    }
};

//delete data with multiple parameters
export const deleteDataWithParameters = async (slug: any) => {
    try {
        const response = await axiosInstance.delete(APP_BASE_URL + slug);
        return response?.data;
    } catch (error) {
        throw error;
    }
};

//delete data with multiple parameters
export const deleteDataWithMultipleParameters = async (slug: any) => {
    try {
        const response = await axiosInstance.get(APP_BASE_URL + slug);
        return response?.data;
    } catch (error) {
        throw error;
    }
};

//common api call end

// csvData api call

export const getCSVDetails = async (slug: any, firstParameterName: any, firstValue: any , secParameterName:any,secValue:any ) => {
    try {
        const response = await axiosInstance(APP_BASE_URL + slug + `${'?' + firstParameterName}=` + firstValue + `${'&'+secParameterName}=` + secValue);
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const getCSVBySlug = async (slug: any ) => {
    try {
        const response = await axiosInstance(APP_BASE_URL + slug);
        return response?.data;
    } catch (error) {
        throw error;
    }
};